<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Batch Approve PDCs</p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Total:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">
              {{ formatCurrency(total) }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <!-- <transition name="fade" mode="out-in"> -->
        <div v-if="step == 1" key="1">
          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <p>Are you sure you would like to approve the PDCs?</p>
            </v-col>
          </v-row>

          <v-expansion-panels :value="0" class="pb-2 my-2" flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2 body-2"
                >PDCs
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider class="mb-0"></v-divider>

                <v-list-item
                  v-for="pdc in pdcs"
                  :key="`pdc_${pdc.refNo}`"
                  three-line
                >
                  <v-list-item-avatar color="grey">
                    <p class="caption white--text">
                      {{ pdc.refNo }}
                    </p>
                    <!-- <v-icon class="grey lighten-1" dark> mdi-cash </v-icon> -->
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">
                      Amount:
                      {{ formatCurrency(pdc.amount) }}</v-list-item-title
                    >
                    <v-list-item-subtitle class="d-flex flex-row caption">
                      Check no: {{ pdc.checkNumber }}
                      <div class="flex-grow-1"></div>
                      Bank:
                      {{ pdc.bank }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="pdc.description"
                      class="caption"
                    >
                      Description:
                      {{ pdc.description }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="caption grey--text">
                      No description provided
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mb-1"></v-divider>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary"
              text
              @click="finish()"
              >Yes</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >No</v-btn
            >
          </v-card-actions>
        </div>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { formatCurrency } from '../../util/currency'
export default {
  data() {
    return {
      formatCurrency,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      pdcs: [],
      total: 0,
      step: 1,
      confirmSendEmail: false
    }
  },
  methods: {
    async open({ pdcs }) {
      this.loading = true
      this.dialog = true
      this.pdcs = pdcs
      this.total = pdcs.reduce((total, pdc) => total + pdc.amount, 0)
      this.step = 1
      this.confirmSendEmail = false

      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.loading = true
      if (
        await this.$store.dispatch('pdcs/batchApprovePDCs', {
          pdcs: this.pdcs
        })
      ) {
        this.$root
          .$confirm({
            title: 'Approve Batch PDCs',
            message: `The PDCs has been approved.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.dialog = false
            this.resolve(this.pdcs)
          })
      } else {
        this.$root
          .$confirm({
            title: 'Approve Batch PDCs',
            message: `There was an error processing your request.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-expansion-panel {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
